"use strict";

export var formatTelephone = function formatTelephone(telephoneNumber) {
  return telephoneNumber.replace(/[^(\d|+)]/g, "");
};